export default __webpack_public_path__ + "static/media/ic_arrow_right_active.2312ed57.svg";